<template>
    <div id="navigation">
    <ul class="nav-ul">
        <li><a href="/#features" @click="goSection($event, 'features')">Features</a></li>
        <li><a href="/#demo" @click="goSection($event, 'demo')">Demo</a></li>
        <li><a href="/#panels" @click="goSection($event, 'panels')">Panels</a></li>
        <!-- <li><a href="/#creators" @click="goSection($event, 'creators')">Creators</a></li> -->
        <li><a href="/#pricing" @click="goSection($event, 'pricing')">Pricing</a></li>
        <li><a href="/#news" @click="goSection($event, 'news')">News</a></li>
        <li><a href="/#faq" @click="goSection($event, 'faq')">FAQ</a></li>
        </ul>
    </div>
</template>

<script>
export default {
  methods: {
    // Section links work from any route: scroll in place when on home,
    // otherwise route to home with the hash (router scrollBehavior scrolls).
    goSection (e, id) {
      e.preventDefault()
      const el = this.$route.path === '/' ? document.getElementById(id) : null
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      } else {
        this.$router.push({ path: '/', hash: '#' + id }).catch(() => {})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;700&display=swap');

$base-font-size-px: 16px;
$base-font-size-em: 1em;
$base-font-family: 'Roboto', sans-serif;
$base-line-height: 1.2em;

#navigation {
    padding-right: 0;
    padding-top: 0px;

    .nav-ul {
        display: flex;
        align-items: center;
        justify-content: center;
        // padding: 0;

        li a {
            display: inline-block;
            padding: 8px 20px;
            font-family: $base-font-family;
            font-size: $base-font-size-em * 1;
            letter-spacing: 1.55px;
            line-height: 18.75px;
            font-weight: 400;
            color: #3C3C3B;
        }
        li a:hover {
            color: #E95557;
;
        }
    }
}

</style>
